import React, { useCallback, useMemo } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import { BannerStatus } from 'ui-components/components/banner-message/banner-enums';
import { BannerMessageV2 } from 'ui-components/components/banner-message/banner-message-v2';
import { DropdownMenu } from 'ui-components/components/dropdown-menu';
import { DropdownMenuItem } from 'ui-components/components/dropdown-menu-item';
import { DropdownMenuToggler } from 'ui-components/components/dropdown-menu-toggler';

import { DEFAULT_CANCEL_REASON_ID, SHORT_ANSWER_QUESTION, OTHER_CANCEL_REASON_ID } from '../../../constants';
import { usePaymentAndSubscriptionPageContext } from '../../../context/payment-and-subscription-page-context';
import { CancelReasonDataPropType } from '../prop-types';
import buildCancelReasonList from './cancel-reason-list-builder';
import { messages, cancelReasonMap } from '../../../messages';
import style from '../../../style.module.less';

const CancellationReasonDropdown = ({ cancelReasonData }) => {
  const intl = useIntl();
  const { cancellationInfo, cancelReasonId, setCancelReasonId, setFollowUpCancelReasonId } = usePaymentAndSubscriptionPageContext();

  const { cancelReasons = [] } = cancellationInfo;

  const onChangeCancelReason = useCallback(
    (value) => {
      setCancelReasonId(value);
      const selectedCancelReason = cancelReasonData[value];
      const followUpQuestions = selectedCancelReason?.cancelFollowUpQuestions ?? [];
      const updatedFollowUpReasonId = followUpQuestions[0]?.answerTypeId === SHORT_ANSWER_QUESTION ? null : DEFAULT_CANCEL_REASON_ID;
      setFollowUpCancelReasonId(updatedFollowUpReasonId);
    },
    [cancelReasonData, setCancelReasonId, setFollowUpCancelReasonId],
  );

  const completeCancelReasons = useMemo(() => {
    return buildCancelReasonList(cancelReasons);
  }, [cancelReasons]);

  return (
    <>
      <div className={style['cancellation-label']}>
        <FormattedMessage {...messages.cancellationReason} />
      </div>
      <div className={style['dropdown-wrapper']}>
        <DropdownMenu dropdownMenuShouldHaveWidthOfButton fullWidth>
          <DropdownMenuToggler className={style['cancellation-dropdown']} theme='white'>
            <FormattedMessage {...cancelReasonMap[cancelReasonId]} />
          </DropdownMenuToggler>
          {completeCancelReasons.map((reason) => {
            const { cancelReasonId: rId } = reason;
            return (
              <DropdownMenuItem key={rId} name={rId} onClick={onChangeCancelReason} value={rId}>
                {intl.formatMessage(cancelReasonMap[rId])}
              </DropdownMenuItem>
            );
          })}
        </DropdownMenu>
        {cancelReasonId === OTHER_CANCEL_REASON_ID && (
          <BannerMessageV2
            className={style['other-option-info-banner']}
            content={<FormattedMessage {...messages.otherOptionInfoBanner} />}
            status={BannerStatus.Info}
          />
        )}
      </div>
    </>
  );
};

CancellationReasonDropdown.propTypes = {
  cancelReasonData: CancelReasonDataPropType,
};

export default CancellationReasonDropdown;
